import script from "./ModalOpportunity.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalOpportunity.vue?vue&type=script&setup=true&lang=js"

import "./ModalOpportunity.vue?vue&type=style&index=0&id=444f470d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444f470d"]])

export default __exports__